import { useCallback, useMemo } from 'react';

import Input from '../../../components/Input/Input';

const FormInput = ({ field, ...props }) => {
  const onChange = useCallback(
    (e) => {
      field.handleChange(e.target.value);
    },
    [field],
  );

  const errors = useMemo(() => {
    if (!field.state.meta.isTouched) return;
    return field.state.meta.errors.map((error) =>
      typeof error === 'string' ? error : error.message,
    );
  }, [field.state.meta.errors, field.state.meta.isTouched]);

  return (
    <Input
      {...props}
      name={field.name}
      value={field.state.value}
      onChange={onChange}
      onBlur={field.handleBlur}
      error={errors}
    />
  );
};
export default FormInput;
